<!-- begin::Scrolltop -->
<div ktScrollTop [options]="scrollTopOptions" id="kt_scrolltop" class="scrolltop">
	<i class="la la-arrow-up"></i>
</div>
<!-- end::Scrolltop -->
